import type { App } from 'vue'
import vuetify from './vuetify'
import GTag from '@/plugins/gtag'

export function registerPlugins(app: App) {
  app.use(vuetify)
  app.use(GTag)
}
